<template>
<!-- 	<div class="col-xs-12 col-md-4 col-lg-3">
		<form class="calify form-inline" v-for="x in time">
			<div class="form-group">
				<input type="text" class="form-control">
				<label>{{x.condition}}</label>
			</div>
		</form>
		<ul>
			<li v-for="(item,index) in time" class="kml">{{item.val}}</li>
		</ul>
		<button @click="getDate()">查询</button>
		<button @click="clear()">重置</button>
	</div> -->
	<div class="search_form_data">
		<ul class="search_form_data_ul">
			<li  v-for="(item,index) in searchData" :key="index">
				<label>{{item.condition}}</label>
				<input type="text" v-model="item.val">
			</li>
		</ul>
		<button class="search_form_data_search" @click="nameTabs == 'addmeauOne' ?changeAddmeauDataOnline(searchData): changeAddmeauDataOpen(searchData) ">查询</button>
		<button class="search_form_data_reset" @click="clear()">重置</button>
	</div>
</template>
<style scoped lang="scss">
	//.calify input{
		//display: inline-block;
	//}
	.search_form_data{background-color: #fff;border:1px solid #eee;
		width:100%;
		height:200px;
		position:absolute;
		left:0;
		top:60px;
		z-index:2;
		padding:5px;
		.search_form_data_ul{
			width:80%;
			height:115px;
			display:flex;
			justify-content: space-between;
			li{
				position:relative;
				padding:20px;
				list-style-type:none;
				float:left;
				input{
					height:40px;
					border:1px solid #bababa;
					text-align:center;
				}
				label{
					background-color:#fff;
					position:absolute;
					top:2px;
					left:30px;
					padding:5px;
					font-weight: 100px;
				}
			}
		}
		.search_form_data_search{
			width:150px;
			height:50px;
			margin-left:200px;
			background-color:#1d92be;
			border:1px solid #eee;
			border-radius:4px;
			color:#fff;
		}
		.search_form_data_reset{
			width:150px;
			height:50px;
			margin-left:200px;
			border:1px solid #eee;
			border-radius:4px;
			color:#fff;
			background-color:#bababa;
		}
	}
</style>
<script>
    import {mapGetters,mapActions} from 'vuex'
	import axios from 'axios'
	export default{
		name:'search',
		data(){
			return{
				searchData:[
					{condition:"捆包号",
						val:""
					},
					{condition:"品种",
						val:""
					},
					{condition:"牌号",
						val:""
				},
					{condition:"母卷号",
						val:""
					}
				],
			}
		},
        computed: {
            ...mapGetters({
              nameTabs: 'nameTabs'
            })
        },
		methods:{
            ...mapActions({
                changeAddmeauDataOnline: 'changeAddmeauDataOnline',
                changeAddmeauDataOpen: 'changeAddmeauDataOpen'
            }),
			clear(){
				this.searchData = [
					{condition:"捆包号",
						val:""
					},
					{condition:"品种",
						val:""
					},
					{condition:"牌号",
						val:""
				},
					{condition:"母卷号",
						val:""
					}
				]
			},
		},
	}
</script>



// WEBPACK FOOTER //
// searh.vue?df36b7cc